// Custom component for Log Measurements
// @ts-nocheck
import PropTypes from 'prop-types'
import { keyBy, map } from 'lodash'
import NumberField from './NumberField'
import SelectField from './SelectField'
import { REPORTING_IDS } from '../../../common/constants'

const amountLookup = keyBy(REPORTING_IDS, 'value')

export default function MeasurementField({ amountKey, max, ...props }) {
  const reportingID = amountLookup[amountKey]
  if (!reportingID) return null

  if (reportingID.options) {
    return (
      <SelectField
        {...props}
        required
        options={reportingID.options}
        label={reportingID.label}
      />
    )
  }

  return (
    <div>
      <NumberField
        {...props}
        required
        label={reportingID.label}
        max={reportingID?.max}
      />
      {reportingID?.max && <div style={{ color: 'grey' }}>Max 1</div>}
    </div>
  )
}

MeasurementField.propTypes = {
  amountType: PropTypes.oneOf(map(REPORTING_IDS, 'value')),
}
